import { ApiEndpointTags } from '../imago-mp.types';
import type { Subscription, SubscriptionApiItem } from './subscriptions-query';
import { transformSubscription } from './subscriptions-query';

type SubscriptionDetailResponse = {
    subscription?: SubscriptionApiItem;
};

export const subscriptionByIdQuery = {
    query: (id: string) => ({
        url: `/mp/1/subscriptions/${id}`,
        method: 'get',
    }),
    transformResponse: (
        response: SubscriptionDetailResponse,
        _meta: unknown,
        id: string,
    ): Subscription => {
        const sub = response?.subscription ?? {};
        return transformSubscription({ ...sub, id: sub.id ?? id });
    },
    providesTags: (_result: Subscription | undefined, _error: unknown, id: string) => [
        { type: ApiEndpointTags.Subscription, id },
    ],
};
